import { Injectable, inject } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ResendApteringspaketRequestDTO } from "~app/common/models/arbetsorder/ResendApteringspaketRequestDTO";
import { ResendApteringspaketResultDTO } from "~app/common/models/arbetsorder/ResendApteringspaketResultDTO";
import { BifogaMaskinfilerRequestDto } from "~app/common/models/arbetsorder/maskinlag/BifogaMaskinfilerRequestDto";
import { BifogaMaskinfilerResponseDto } from "~app/common/models/arbetsorder/maskinlag/BifogaMaskinfilerResponseDto";
import { MaskinInformationDTO } from "~app/common/models/arbetsorder/maskinlag/MaskinInformationDTO";
import { ApiClientService } from "~app/common/services/api-client.service";
import { ISandningsloggSearchModel, SandningsloggItemModel } from "../../produktion.models";

@Injectable({
    providedIn: "root"
})
export class SandningsloggSearchService {
    maskin$: BehaviorSubject<MaskinInformationDTO>;

    private readonly apiClientService = inject(ApiClientService);

    constructor() {
        this.maskin$ = new BehaviorSubject<MaskinInformationDTO>(null);
    }

    bifogaMaskinfiler(request: BifogaMaskinfilerRequestDto): Observable<BifogaMaskinfilerResponseDto> {
        return this.apiClientService.post<BifogaMaskinfilerRequestDto, BifogaMaskinfilerResponseDto>("aptering/bifoga", request, false);
    }

    fetchMaskinInfo(maskinnummer: string): void {
        this.apiClientService.get<MaskinInformationDTO>("maskin/GetMaskin", false, { maskinnummer: maskinnummer })
            .subscribe(x => {
                this.maskin$.next(x);
            });
    }

    rensaLogg(maskinnummer: string): Observable<string> {
        return this.apiClientService.post<any, string>("aptering/rensaLogg", { maskinnummer: maskinnummer }, false);
    }

    search(sandningsloggSearchParams: ISandningsloggSearchModel): Observable<SandningsloggItemModel[]> {
        return this.apiClientService.get<SandningsloggItemModel[]>("aptering/sandningslogg", false, sandningsloggSearchParams);
    }

    skickaOmFiler(request: ResendApteringspaketRequestDTO): Observable<ResendApteringspaketResultDTO> {
        return this.apiClientService.post<ResendApteringspaketRequestDTO, ResendApteringspaketResultDTO>("maskin/skickaOmMaskinFiler", request, false);
    }
}
